import { Component, Vue } from 'vue-property-decorator'
import { OrderType } from '@/api/types'

@Component
export default class SalesReportMixin extends Vue {
    isOrderTypeEnabled(type: string): boolean {
        if (!this.$currentCompany.orderSettings.enabled) {
            return false
        }

        return this.$currentCompany.orderSettings.enabledTypes.includes(type as OrderType)
    }

    typeLabel(type: string): string {
        if (this.isOrderTypeEnabled(type)) {
            return this.$t(`reports.salesReport.orderType.${type}`).toString()
        } else {
            return this.$t(`reports.salesReport.referralType.${type}`).toString()
        }
    }

    subjectLabel(subject: string): string {
        return this.$t(`reports.salesReport.subject.${subject}`).toString()
    }

    directionForType(type: string): string {
        if (this.isOrderTypeEnabled(type)) {
            return 'in'
        }

        if (this.$currentCompany.handledIncomingReferralTypes.includes(type)) {
            return 'in'
        } else {
            return 'out'
        }
    }

    directionForTypeLabel(type: string): string {
        if (this.directionForType(type) === 'in') {
            return 'toegewezen aan'
        } else {
            return 'doorverwezen door'
        }
    }
}
